<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0175 8.14777L16.8975 3.39192C17.4195 2.68488 16.9643 1.66666 16.089 1.66666L1.87413 1.66666C0.999247 1.66666 0.516145 2.68488 1.06806 3.36555L6.94451 10.612V13.6458C6.94451 13.9006 7.06584 14.1396 7.27075 14.2858L9.39948 15.8092C9.13116 15.14 8.98157 14.4108 8.98157 13.6458C8.98157 11.0449 10.6876 8.84438 13.0175 8.14777Z"
      fill="#325EA3"
    />
    <path
      d="M17.8244 10.3313C16.0352 8.50134 13.1318 8.50134 11.3425 10.3313C9.55328 12.1612 9.5526 15.1298 11.3425 16.9604C13.1325 18.791 16.0345 18.791 17.8244 16.9604C19.6144 15.1298 19.6137 12.1612 17.8244 10.3313ZM15.0921 15.7266C15.0921 16.014 14.8644 16.2473 14.5833 16.2475C14.3023 16.2476 14.0746 16.0141 14.0744 15.7266V14.1655H12.548C12.2671 14.1655 12.0389 13.9326 12.0387 13.6451C12.0385 13.3576 12.2669 13.1249 12.548 13.1247H14.0744L14.0744 11.5636C14.0744 11.2762 14.3021 11.0429 14.5833 11.0427C14.8644 11.0425 15.092 11.2761 15.0922 11.5636V13.1247H16.6186C16.8995 13.1247 17.1277 13.3575 17.1277 13.6449C17.1276 13.9322 16.8995 14.1651 16.6184 14.1653H15.092L15.0921 15.7266Z"
      fill="#325EA3"
    />
  </svg>
</template>
